import {BaseClientConfig} from "./BaseClientConfig";

export type EnergyUnit = 'kcal'|'kj';

export const energyUnitOpts: Record<EnergyUnit, {
    name: string,
    coefficient: number,
}> = {
    kcal: { name: "kCal", coefficient: 1 },
    kj: { name: "kJ", coefficient: 4.185 },
}

export class FrontAppConfig extends BaseClientConfig {

    public notify: boolean|null =  null;

    public notifyTypes: ('plan'|'note'|'watch')[] = [ 'plan', 'note' ];

    public lastSync: Date|null = null;

    public theme: 'auto'|'dark'|'light' = 'auto';

    public fontSize: number = 100;

    public energyUnit: EnergyUnit = 'kcal';

    protected afterLoadItem(item: { value: any; key: string }) {
        if (item.key === 'lastSync') {
            item.value = item.value ? new Date(item.value) : null;
        }
    }

    constructor() {
        super('frontAppConfig');
    }

    subscriptionConfig(): any
    {
        return {
            notifyPlan: this.notifyTypes.includes('plan') && this.notify,
            notifyTrainerNote: this.notifyTypes.includes('note') && this.notify,
            notifyBefore: 600,
        }
    }

    static themeClasses = ['auto', 'dark', 'light'];

    public applyVisual(custom: Partial<FrontAppConfig> = {}) {
        const values = { ...this, ...custom };
        const html = document.querySelector('html')!;
        html.style.fontSize = values.fontSize + '%';
        for (const cls of FrontAppConfig.themeClasses) {
            html.classList.toggle('theme-' + cls, cls === values.theme);
        }
    }
}

export const frontAppConfig = new FrontAppConfig();
// frontAppConfig.loadConfig();
